import { render, staticRenderFns } from "./Promo.vue?vue&type=template&id=0c433fa0&scoped=true&"
import script from "./Promo.vue?vue&type=script&lang=js&"
export * from "./Promo.vue?vue&type=script&lang=js&"
import style0 from "./Promo.vue?vue&type=style&index=0&id=0c433fa0&scoped=true&lang=scss&"
import style1 from "./Promo.vue?vue&type=style&index=1&id=0c433fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c433fa0",
  null
  
)

export default component.exports